__turbopack_context__.v({
  "actionCard": "page-module__Fx1_7W__actionCard",
  "actionDescription": "page-module__Fx1_7W__actionDescription",
  "actionIcon": "page-module__Fx1_7W__actionIcon",
  "actionTitle": "page-module__Fx1_7W__actionTitle",
  "actionsGrid": "page-module__Fx1_7W__actionsGrid",
  "addPositionButton": "page-module__Fx1_7W__addPositionButton",
  "arbitrage": "page-module__Fx1_7W__arbitrage",
  "arrowIcon": "page-module__Fx1_7W__arrowIcon",
  "backgroundShift": "page-module__Fx1_7W__backgroundShift",
  "blue": "page-module__Fx1_7W__blue",
  "changeBadge": "page-module__Fx1_7W__changeBadge",
  "concentrated": "page-module__Fx1_7W__concentrated",
  "contentContainer": "page-module__Fx1_7W__contentContainer",
  "contentSection": "page-module__Fx1_7W__contentSection",
  "cyan": "page-module__Fx1_7W__cyan",
  "dashboardContainer": "page-module__Fx1_7W__dashboardContainer",
  "fadeIn": "page-module__Fx1_7W__fadeIn",
  "farming": "page-module__Fx1_7W__farming",
  "green": "page-module__Fx1_7W__green",
  "headerActions": "page-module__Fx1_7W__headerActions",
  "headerContent": "page-module__Fx1_7W__headerContent",
  "headerIcon": "page-module__Fx1_7W__headerIcon",
  "headerInfo": "page-module__Fx1_7W__headerInfo",
  "headerSection": "page-module__Fx1_7W__headerSection",
  "headerText": "page-module__Fx1_7W__headerText",
  "iconButton": "page-module__Fx1_7W__iconButton",
  "mainCard": "page-module__Fx1_7W__mainCard",
  "mainCardHeader": "page-module__Fx1_7W__mainCardHeader",
  "mainCardIcon": "page-module__Fx1_7W__mainCardIcon",
  "mainCardTitle": "page-module__Fx1_7W__mainCardTitle",
  "metric": "page-module__Fx1_7W__metric",
  "metricLabel": "page-module__Fx1_7W__metricLabel",
  "metricValue": "page-module__Fx1_7W__metricValue",
  "metricsGrid": "page-module__Fx1_7W__metricsGrid",
  "negative": "page-module__Fx1_7W__negative",
  "neutral": "page-module__Fx1_7W__neutral",
  "orange": "page-module__Fx1_7W__orange",
  "pink": "page-module__Fx1_7W__pink",
  "positionCard": "page-module__Fx1_7W__positionCard",
  "positionHeader": "page-module__Fx1_7W__positionHeader",
  "positionInfo": "page-module__Fx1_7W__positionInfo",
  "positionTitle": "page-module__Fx1_7W__positionTitle",
  "positionsContainer": "page-module__Fx1_7W__positionsContainer",
  "positive": "page-module__Fx1_7W__positive",
  "purple": "page-module__Fx1_7W__purple",
  "sectionDivider": "page-module__Fx1_7W__sectionDivider",
  "statCard": "page-module__Fx1_7W__statCard",
  "statCardHeader": "page-module__Fx1_7W__statCardHeader",
  "statIcon": "page-module__Fx1_7W__statIcon",
  "statLabel": "page-module__Fx1_7W__statLabel",
  "statValue": "page-module__Fx1_7W__statValue",
  "statsGrid": "page-module__Fx1_7W__statsGrid",
  "strategyBadge": "page-module__Fx1_7W__strategyBadge",
  "white": "page-module__Fx1_7W__white",
  "yellow": "page-module__Fx1_7W__yellow",
});
